import React from 'react';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const CheckoutOrderSummary = () => {
  const { shippingConfirmed, zhipsterData } = useTypedSelector(
    (state) => state.checkout.payload
  );
  const cart = useTypedSelector((state) => state.cart);

  return (
    <div className="flex flex-col">
      <div className="flex justify-between py-1 text-lg font-normal">
        <span>{translate('checkout.order.sum')}</span>
        <span className="text-right">{cart.productTotal}</span>
      </div>
      {cart.discount && (
        <div
          className={clsx(
            'flex justify-between py-1 text-lg font-normal',
            'text-error'
          )}
        >
          <span>{translate('checkout.order.saved')}</span>
          <span className="text-right">{cart.discount}</span>
        </div>
      )}
      {cart.deliveryCost && (
        <div className="flex justify-between py-1 text-lg font-normal">
          <span>{translate('checkout.order.shipping')}</span>
          <span className="text-right">
            {shippingConfirmed || !!zhipsterData?.selectedDropPointId
              ? cart.deliveryCost
              : translate('checkout.no-shipping-selected')}
          </span>
        </div>
      )}
      {cart.fees?.map((fee, idx) => (
        <div
          className="flex justify-between py-1 text-lg font-normal"
          key={fee.name + idx}
        >
          <span>{fee.name}</span>
          <span className="text-right">{fee.cost}</span>
        </div>
      ))}

      <div
        className={clsx(
          'flex justify-between pb-1 pt-2 text-lg',
          'font-bold'
        )}
      >
        <h3>{translate('checkout.order.grandTotal')}</h3>
        <h3 className="text-right">{cart.grandTotal}</h3>
      </div>
      <div className="flex justify-between py-1 text-lg font-normal">
        <span>{translate('checkout.order.vat')}</span>
        <span className="text-right">{cart.vat}</span>
      </div>
    </div>
  );
};

export default CheckoutOrderSummary;
